var _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuNotifyIcon = function SvgMenuNotifyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1.5,
    x: 11,
    y: 16,
    fill: "#fff",
    rx: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 1.5,
    x: 11,
    y: 26,
    fill: "#fff",
    rx: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 15,
    r: 3,
    fill: "#BDD900"
  })));
};
export { SvgMenuNotifyIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSI+PHJlY3QgeD0iMTEiIHk9IjE2IiB3aWR0aD0iMTQiIGhlaWdodD0iMS41IiByeD0iLjgiIGZpbGw9IiNmZmYiLz48cmVjdCB4PSIxMSIgeT0iMjYiIHdpZHRoPSIyMiIgaGVpZ2h0PSIxLjUiIHJ4PSIuOCIgZmlsbD0iI2ZmZiIvPjxjaXJjbGUgY3g9IjMwIiBjeT0iMTUiIHI9IjMiIGZpbGw9IiNCREQ5MDAiLz48L3N2Zz4K";